export enum CookieKeys {
  GCLID = 'gclid',
  SUBSCRIBED = 'subscribed',
  UNLOCK = 'unlock',
  SALES_ACCESS_COOKIE_NAME = 'sales_events_access'
}
